<template>
  <div class="comp-menu">
    <div class="comp-menu-left">
      <router-link
        class="comp-menu-item"
        v-for="(item, index) in gong_neng_list"
        :key="index"
        :to="item.url"
        :disabled="item.disabled"
      >
        {{ item.key }}
      </router-link>
    </div>
    <div class="comp-menu-right">
      <div class="flex flex-y-center">
        <el-link type="primary" @click.native="goNewPage">新开当前页</el-link>
        <span class="m-x-2 c-gray-light">丨</span>
        <el-link type="primary" @click.native="goRefreshPage">刷新</el-link>
        <span class="m-x-2 c-gray-light">丨</span>
        <el-link type="primary" @click.native="goBackPage">返回</el-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gong_neng_list: [
        {
          key: '客户列表',
          url: '/new/customer/user',
          disabled: false
        },
        {
          key: '核算单列表',
          url: '/new/verify/list',
          disabled: false
        },
        {
          key: '订单列表',
          url: '/new/order/list',
          disabled: false
        },
        {
          key: '工程协同列表',
          url: '/new/gongcheng/list',
          disabled: false
        },
        {
          key: '工序列表',
          url: '/new/gongxu/list',
          disabled: false
        },
        {
          key: '工艺列表',
          url: '/new/gongyi/list',
          disabled: false
        },
        {
          key: '生产班组列表',
          url: '/new/banzu/list',
          disabled: false
        },
        {
          key: '设备列表',
          url: '/production/she-bei/list',
          disabled: false
        },
        {
          key: 'PMC订单列表',
          url: '/new/pmc/list',
          disabled: false
        },
        {
          key: '采购申请列表',
          url: '/new/purchase/apply/list',
          disabled: false
        },
        {
          key: '生产工单列表',
          url: '/new/renwu/list',
          disabled: false
        },
        {
          key: '委外工单列表',
          url: '/new/weiwai/list',
          disabled: false
        },
        {
          key: '送货单列表',
          url: '/new/delivery/list',
          disabled: false
        }
      ]
    }
  },
  methods: {
    // 新开当前页
    goNewPage() {
      window.open(this.$route.fullPath, '_blank')
    },
    // 刷新当前页
    goRefreshPage() {
      window.location.reload()
    },
    // 返回上一页
    goBackPage() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.comp-menu {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 28px;
  padding: 5px 10px;
  background: @colorGrayF;
  border-top: 1px solid @colorGrayD;
  border-bottom: 1px solid @colorGrayD;
  z-index: 99;
  .comp-menu-left {
    display: flex;
    align-items: center;
    .comp-menu-item {
      height: 26px;
      line-height: 26px;
      padding: 0 5px;
      border-radius: 4px;
      text-decoration: none;
      color: @colorGray;
      background: @colorWhite;
      border: @border;
      cursor: pointer;
      & ~ .comp-menu-item {
        margin-left: 5px;
      }
      &.router-link-active {
        color: @colorWhite;
        background: #396bf6;
        border-color: #396bf6;
      }
    }
  }
  .comp-menu-right {
    display: flex;
    align-items: center;
  }
}
</style>
